import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdAttachMoney } from 'react-icons/md';

export default class ApuracaoVendas extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados, tipo } = this.props;

        let Secao = ({ titulo, item }) => (
            <Box mb={2}>
                <Typography fontSize={11} color="#6b7a92" mb={0.8}><b>{titulo}</b></Typography>
                <Stack direction="row" gap={3}>
                    <Box>
                        <Typography fontSize={10} color="#6b7a92">Valor de venda</Typography>
                        <Typography fontSize={15} fontWeight={600} color={item?.venda === 0 ? '#9ca3af' : '#1f2937'}>{item?.venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={10} color="#6b7a92">Valor de custo</Typography>
                        <Typography fontSize={15} fontWeight={600} color={item?.custo === 0 ? '#9ca3af' : '#1f2937'}>{item?.custo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                    </Box>
                </Stack>
            </Box>
        );

        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                        <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" alignItems="center" gap={1} p={1.2}>
                            <MdAttachMoney />
                            <Typography variant="caption"><b>Vendas - Depósitos alternativos</b></Typography>
                            <Box flex={1.0} />
                            <Stack direction="row" bgcolor="#0A57A3" color="white" alignItems="center" p={0.5} borderRadius={2}>
                                <Typography fontSize={10}>{tipo}</Typography>
                            </Stack>
                        </Stack>
                        <Box p={2}>
                            <Secao titulo="Depósito avaria" item={dados?.avaria} />
                            <Secao titulo="Depósito segregado" item={dados?.segregado} />
                        </Box>
                    </Stack>
                }
            </>
        );
    }
}
